<template>
    <div class="w-100 cp" style="" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
        <p class="mb-2 text-center text-md-start border-bottom">
            Today's play count
        </p>
        <h5 class="mb-0 text-center text-md-start text-white fw-bold">
            {{totalCount}}
        </h5>

      <!-- Modal -->
      <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div class="modal-content" style="background: #050F1E!important;">
            <div class="modal-header">
              <h5 class="modal-title text-white" id="staticBackdropLabel">Today's play count</h5>
              <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="d-flex flex-wrap justify-content-center align-items-center gap-2 gap-sm-2">
                <div style="width: 140px" class="card bg-primary  align-items-center justify-content-center text-white">
                  <div>
                    <h4>Web</h4>
                    <h5>{{webCount}}</h5>
                  </div>
                </div>
                <div style="width: 140px" class="card bg-info  align-items-center justify-content-center text-white">
                  <div>
                    <h4>App</h4>
                    <h5>{{appCount}}</h5>
                  </div>
                </div>
                <div style="width: 140px" class="card bg-secondary  align-items-center justify-content-center text-white">
                  <div>
                    <h4>Free</h4>
                    <h5> {{free}}</h5>
                  </div>
                </div>
                <div style="width: 140px" class="card bg-light align-items-center justify-content-center text-black">
                  <div>
                    <h4>Paid</h4>
                    <h5> {{paid}}</h5>
                  </div>
                </div>
                <div style="width: 140px" class="card bg-success align-items-center justify-content-center text-white">
                  <div>
                    <h4>Total</h4>
                    <h5> {{totalCount}}</h5>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table caption-top table-success table-striped">
                    <caption class="text-white">Daily Top 10 Audios List</caption>
                    <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Audiobook Id</th>
                      <th scope="col">Audiobook Name</th>
                      <th scope="col">Total Played</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(data, index) in todayTop10Audio" :key="index">
                      <th scope="row">{{index+1}}</th>
                      <td>{{ data.audiobook_id }}</td>
                      <td>{{ data.audiobook_name }}</td>
                      <td>{{ data.total_played }}</td>
                    </tr>
                    </tbody>
                </table>
              </div>
              <div class="table-responsive">
                <table class="table caption-top table-success table-striped">
                    <caption class="text-white">Daily Top 10 Users List</caption>
                    <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th class="text-capitalize" scope="col">user id</th>
                      <th class="text-capitalize" scope="col">user name</th>
                      <th class="text-capitalize" scope="col">full name</th>
                      <th class="text-capitalize" scope="col">address</th>
                      <th class="text-capitalize" scope="col">total views</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(data, index) in todayTop10User" :key="index">
                      <th scope="row">{{ index+1 }}</th>
                      <td>{{data.user_id}}</td>
                      <td>{{data.user_name}}</td>
                      <td>{{data.full_name}}</td>
                      <td>{{data.address}}</td>
                      <td>{{data.total_views}}</td>
                    </tr>
                    </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data(){
        return{
            totalCount:'',
            todayTop10Audio: [],
            todayTop10User: [],
            webCount:'',
            appCount:'',
            free:'',
            paid:''
        }
    },
  async created(){
    await this.playCount();
    await this.topAudio();
    await this.topUser();
  },
    methods:{
        async playCount(){
            const token = localStorage.getItem(this.$tokenKey);
            const res = await axios.get(
                this.$baseUrl + this.$api + this.$version1 + "/kabbikanalytics/today-total-play-count",{
                    headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/json",
                    }
                }
            );
            if(res.status==200){
             this.totalCount = res.data.total_played;
              this.webCount = res.data.web;
              this.appCount = res.data.android
              this.free = res.data.free
              this.paid = res.data.paid
            }
        },
        async topUser(){
            const token = localStorage.getItem(this.$tokenKey);
          let sDate = this.$filters.formatDateTM(new Date());

          let eDate = this.$filters.formatDateTM(new Date());
            const res = await axios.get(
                this.$baseUrl + this.$api + this.$version1 + "/kabbikanalytics/top-10-users?startDate=" + sDate + "&endDate=" + eDate,{
                    headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/json",
                    }
                }
            );
            if(res.status===200){
              //console.log('top user', res.data)
              this.todayTop10User = res.data;
            }
        },
        async topAudio(){
            const token = localStorage.getItem(this.$tokenKey);
          let sDate = this.$filters.formatDateTM(new Date());

          let eDate = this.$filters.formatDateTM(new Date());
            const res = await axios.get(
                this.$baseUrl + this.$api + this.$version1 + "/kabbikanalytics/top-10-audios?startDate=" + sDate + "&endDate=" + eDate,{
                    headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/json",
                    }
                }
            );
            if(res.status===200){
              console.log('top user', res.data)
              this.todayTop10Audio = res.data;
            }
        },
    },
}
</script>
